console.log('including common...');
/////////////////////////////////////////////
///////////// Execute stuff /////////////////
/////////////////////////////////////////////
import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui/ui/widgets/mouse';
import 'jquery-ui-touch-punch';
import Dropzone from 'dropzone';
import Popper from 'popper.js'
import 'bootstrap';
import './bootstrap-table.js'
import '@fortawesome/fontawesome-free/js/all';
import katex from 'katex';
import bsCustomFileInput from 'bs-custom-file-input'
import moment from 'moment';
import 'moment-timezone';
import { isSet } from 'lodash';

// set globals
window.$ = $;
// window.jQuery = $;
window.Dropzone   = Dropzone;
window.Popper     = Popper;
window.katex      = katex;
window.moment     = moment;


// some setup
$(function() {
	// convert some configs
	window.configGEMS.moment_time_format_short = window.phpToMomentDateFormat(window.configGEMS.cfg_time_format_short);
	window.configGEMS.moment_time_format_long  = window.phpToMomentDateFormat(window.configGEMS.cfg_time_format_long);
	window.configGEMS.moment_date_format_short = window.phpToMomentDateFormat(window.configGEMS.cfg_date_format_short);
	window.configGEMS.moment_date_format_long  = window.phpToMomentDateFormat(window.configGEMS.cfg_date_format_long);
	window.configGEMS.moment_datetime_format_short = window.phpToMomentDateFormat(window.configGEMS.cfg_datetime_format_short);
	window.configGEMS.moment_datetime_format_long = window.phpToMomentDateFormat(window.configGEMS.cfg_datetime_format_long);
});
$.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }}); // puts csrf token in ajax calls
$(window  ).on('load', function() {
	$("form").each(function (){
		if($(this).attr('method') && $(this).attr('method').toUpperCase() === "POST")
			$(this).prepend(csrf_token_field_html);
	});}); // puts csrf token in any post forms
$(function() { window.reloadTooltipPopover();}); // load bootstrap tooltips and popovers
$(function() {
	// hide any open popovers but targeted one
	$('body').on('click', function (e) {
		$('[data-toggle=popover]').each(function () {
			if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
				$(this).popover('hide');
			}
		});
	});

	// init custom file input
	bsCustomFileInput.init()
});



/////////////////////////////////////////////
//////////////// FUNCTIONS //////////////////
/////////////////////////////////////////////

window.url = function(route){
	if(!route) route = '';
	return cfg_product_root+route;
}
window.backOrClosePopup = function(){
	var opener = window.opener;
	// var opener = window.opener.location
	if(opener) {
		// it's a popup
		window.close();
	}else{
		// it's not a popup
		history.go(-1)
	}
}

window.disposeTooltip = function(){
	$('[data-toggle=tooltip]').tooltip('dispose');
}
window.reloadTooltipPopover = function(){
	console.log('(re)loading tooltips and popovers');
	// reload tooltips
	if($('[data-toggle=tooltip]').length > 0) $("body").tooltip({ selector: '[data-toggle=tooltip]' });

	// reload popovers
	var popovers = $('[data-toggle=popover]');
	if(popovers.length > 0) $("body").popover({ selector: '[data-toggle=popover]' });
	popovers.on('shown.bs.popover',function(a,b,c){
		// render katex for all elements marked as .mimetex2katex
		window.loadKatex();
	})

	// add tooltip and add a line (tooltips will have the popover title) in the tooltip for all elements with popovers to
	popovers.tooltip({placement:'right'});
	popovers.on('shown.bs.tooltip',function(){
		var tooltipid = $(this).attr('aria-describedby')
		$('#'+tooltipid+' .tooltip-inner').append(`
			<br>
			<small class="text-muted">
				Click to expand
			</small>
			`);
	})
	popovers.on('show.bs.popover',function(){
		$(this).tooltip('hide');
	})

	// convert local datetime
	window.displayLocalDateTime();
}
window.reloadBootstrapTables = function(){
	$('[data-toggle=table]').bootstrapTable('destroy').bootstrapTable();
}


window.displayLocalDateTime = function(){
	$('.utc-to-local-datetime').each(function(k,e){ $(e).text(window.dateStringFormat($(e).data('iso-datetime'), window.configGEMS.moment_datetime_format_short)); });
	$('.utc-to-local-date'    ).each(function(k,e){ $(e).text(window.dateStringFormat($(e).data('iso-datetime'), window.configGEMS.moment_date_format_short)); });
	$('.utc-to-local-time'    ).each(function(k,e){ $(e).text(window.dateStringFormat($(e).data('iso-datetime'), window.configGEMS.moment_time_format_short)); });
}
window.dateStringFormat = function(date, format){
	var moment = window.moment(date).tz(window.moment.tz.guess());
	return moment.format(format);
}
window.loadKatex = function(){
	// katex
	$('.mimetex2katex').each(function(k,e){
		katex.render($(e).html().replace(/&amp;/g,"&"), e);
	})
}

window.getHTTPMetaTag = function(metaName) {
	const metas = document.getElementsByTagName('meta');
	for (let i = 0; i < metas.length; i++) {
		if (metas[i].getAttribute('name') === metaName) {
		return metas[i].getAttribute('content');
		}
	}
	return '';
}

window.waitForElement = function (selector, callback) {
  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

window.getAllUrlParams = function(url) {

	// get query string from url (optional) or window
	var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

	// we'll store the parameters here
	var obj = {};

	// if query string exists
	if (queryString) {

	  // stuff after # is not part of query string, so get rid of it
	  queryString = queryString.split('#')[0];

	  // split our query string into its component parts
	  var arr = queryString.split('&');

	  for (var i = 0; i < arr.length; i++) {
		// separate the keys and the values
		var a = arr[i].split('=');

		// set parameter name and value (use 'true' if empty)
		var paramName = a[0];
		var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

		// (optional) keep case consistent
		paramName = paramName.toLowerCase();
		if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

		// if the paramName ends with square brackets, e.g. colors[] or colors[2]
		if (paramName.match(/\[(\d+)?\]$/)) {

		  // create key if it doesn't exist
		  var key = paramName.replace(/\[(\d+)?\]/, '');
		  if (!obj[key]) obj[key] = [];

		  // if it's an indexed array e.g. colors[2]
		  if (paramName.match(/\[\d+\]$/)) {
			// get the index value and add the entry at the appropriate position
			var index = /\[(\d+)\]/.exec(paramName)[1];
			obj[key][index] = paramValue;
		  } else {
			// otherwise add the value to the end of the array
			obj[key].push(paramValue);
		  }
		} else {
		  // we're dealing with a string
		  if (!obj[paramName]) {
			// if it doesn't exist, create property
			obj[paramName] = paramValue;
		  } else if (obj[paramName] && typeof obj[paramName] === 'string'){
			// if property does exist and it's a string, convert it to an array
			obj[paramName] = [obj[paramName]];
			obj[paramName].push(paramValue);
		  } else {
			// otherwise add the property
			obj[paramName].push(paramValue);
		  }
		}
	  }
	}
	return obj;
}
window.addSpinner = function(element, change_text_to_loading = true){

    // this function replaces the text, it is irreversible
    var element = $(element);
    var spinner_html = '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>';
    // for spinner:
    // <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

    // exit if not compatible (not able to include html in the button, such as input)
    if(!element.is('button')) return;

    if(change_text_to_loading){
        var old_html = element.html();

        // change text for the spinner
        element.html(' '+spinner_html+' Loading... ');

        // put the old text as tooltip
        element.data('toggle', 'tooltip');
        element.data('html', true);
        element.attr('title', old_html);
        element.tooltip();
    } else {
        // add the spinner
        element.append(' '+spinner_html+' ');
    }

}
window.post = function(url, fields, options){
    if(typeof options === 'object' && 'spinner' in options){
        window.addSpinner(options.spinner, false);
    }
    if(typeof options === 'object' && 'spinnerFull' in options){
        window.addSpinner(options.spinnerFull, true);
    }
	if(typeof options === 'object' && options.target == '_popup'){
		var popup_options = {
			scrollbars:'no',
			resizable:'no',
			status:'no',
			location:'no',
			toolbar:'no',
			menubar:'no',
			width:1024,
			height:700,
		}
		if(typeof options.popup_options === 'object'){
			$.each(options.popup_options,function(k,v){
				var v2 = v;
				if(v === true) v2 = 'yes';
				if(v === false) v2 = 'no';
				popup_options[k] = v2;
			})
		}
		var popup_options_string = Object.keys(popup_options).map(function(k) {
			return k+"="+popup_options[k];
		}).join(',');

		var popup = window.open('',options.popup_title??'', popup_options_string);
		$(popup.document).ready(function(){
			// WARNING: ready() is deprecated but it doesn't work with on('ready', ...)
			postPopulate(popup.document.body, url, fields, options);
		})
	} else {
		postPopulate(window.document.body, url, fields, options);
	}
}

window.postPopulate = function(body, url, fields, options){
	var form = $('<form></form>');
	form.hide();
	form.attr("action",url);
	form.attr("method","POST");
	if(typeof options === 'object' && options.target == '_blank') form.attr("target","_blank");
	form.append(csrf_token_field_html);

	$.each(fields,function(k,v){
		var tag = "input";
		if(/\r|\n/.exec(v)) tag = "textarea";

		if(typeof v === 'array' || typeof v === 'object'){
			$.each(v,function(y,z){
				var field = $('<'+tag+'></'+tag+'>');
				field.attr("name",k+'[]');
				field.attr("value",z);
				form.append(field);
			});
		} else {
			var field = $('<'+tag+'></'+tag+'>');
			field.attr("name",k);
			field.attr("value",v);;
			form.append(field);
		}
	})

	form.appendTo(body).trigger("submit");
}

window.loadPopupModal = function(url){
	url = url.replace("?", "&");
	var popup_url = cfg_product_root+'popupasync?pupup_async_modal_url='+current_route_dir+'/'+url;
	console.log(popup_url);
	$.ajax({
			url: popup_url,
			type: 'GET',
			error: function() {
				console.log('failed to load async');
			},
			success: function(data) {
				appendPopupModalElement(data)
			}
		});
}

window.showPopupModal = function(){
	$('#PopupModal').modal({
		backdrop: false,
		show: true
	});
}
window.hidePopupModal = function(){
	$('#PopupModal').modal({
		backdrop: false,
		show: false
	});
}
window.appendPopupModalElement = function(data){
	// console.log(data);
	// var dom_nodes = $($.parseHTML(data));
	// var new_element_html = dom_nodes.find('#PopupModal').html()
	// console.log(new_element_html);
	$('#app').append($(data));


	window.showPopupModal();
}


window.lockbutonwaitButtonAnimation = function(elem) {
	elem.style.width = elem.offsetWidth;
	var i = 0;
	var id = setInterval(frame, 60);
	wait_interval_id = id;
	var text_loop = "           •••           ".split('');

	function frame() {
		if (Elbtn_wait_anim_stop) return;
		if (i == (text_loop.length - 1)) i = 0;
		else i++;
		text_loop.move(-1,0);
		elem.value = text_loop.join("").substring(0,text_loop.length / 3 * 2 );
	}
}

window.sendRequest = function(method,uri,options,element_spinner){
	if (!options) options = {};
	if (!uri.match(/^http/i)) uri = cfg_product_root+uri.replace(/^\/*/,'');
	var spinner_element = $(element_spinner)
	if(spinner_element.next('.invalid-feedback'))spinner_element.next('.invalid-feedback').remove()

	var previous_html = spinner_element.html();
	spinner_element.prop('disabled',true);
	spinner_element.html($(`
		<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
		<span>Loading...</span>
	`))
	var end_spinner = function(){
		spinner_element.html(previous_html);
		spinner_element.prop('disabled',false);
	}

	// if(is a input/button)

	try{
		var resp = false;
		$.ajax({
			async : false,
			url : uri,
			data: options,
			cache: true,
			type: method,
			dataType : "json",
			// beforeSend : function(){return;},
			success : function(data){
				resp = data;
				end_spinner()
				// console.log('response success:',data)
				return true;
			},
			error: function(e){
				var invalid_div = $(`<div class="invalid-feedback"></div>`)

				// if(e.status != 200)
				var error_message = '';
				if(e.responseJSON && e.responseJSON['messages']) error_message = e.responseJSON['messages'].join('<br>');
				else {
					error_message = 'Status '+e.status+': '+e.statusText
				}


				invalid_div.html(error_message)

				spinner_element.after(invalid_div);
				spinner_element.addClass('is-invalid');

				// console.log(invalid_div)

				// console.log(e.status);
				// console.log(e.statusText);
				// console.log(e.responseText)
				// console.log(e);
				end_spinner()


				if( 'responseJSON' in e  && 'errors' in e.responseJSON){
					$.each(e.responseJSON.errors,function(field, messages){

						var culprit = $('[name="'+field+'"]');
						// culprit.removeClass('is-invalid')
						culprit.addClass('is-invalid');

						var display_element_after;

						if(culprit.is('[type="checkbox"],[type="radio"]')){
							// if checkbox or radio, the label is after
							display_element_after = culprit.last().next('label');
						} else {
							display_element_after = culprit.last();
						}
						display_element_after.next('.invalid-feedback').remove();
						display_element_after.after($('<div class="invalid-feedback">'+messages.join('<br>')+'</div>'));
					})
				}



				return false;
			}
		});
		return resp;
	}catch(err){
		end_spinner()
		console.log('ajax error caught',err)
		return false;
	}
}

window.requestLegacyPopup = function(url,method, options = {}){
	if(method === undefined) method = 'GET';
	$.ajax({
		url: url,
		type: method,
		beforeSend: function(jqXHR, settings) {
			jqXHR.url = url;
		},
		error: function() {
			console.log('failed to load async');
		},
		success: function (responseData,status,xhr) {
			window.handleLegacyPopupModalResponse(responseData,status,xhr, options)
		}
	});
}
window.wasLegacyPopupClosed = function(htmlData){
	return /^\s*<script/.test(htmlData) // if the page starts with a scrip, it usually means a PHP function such as JavaScriptBootstrapTableRefreshOpenerAndClose() was used
		|| /^\s*$/.test(htmlData) // if nothing is displayed, we assume this is closed
}
window.legacyPopupModalFindAll = function(htmlData){
	return $('div[id^="modal-"].modal.fade');
}
window.legacyPopupModalDispose = function(htmlData){
	document.activeElement.blur();
	window.legacyPopupModalFindAll().modal('hide');
}

window.handleLegacyPopupModalResponseFailure = function(xhr, form){

	if (xhr.status === 422) {
		window.showValidationErrors(form[0], xhr.responseJSON);
		return;
	} else {
		// General errors (500, 404, network issues)
		const summary = document.createElement('div');
		summary.className = 'alert alert-danger validation-summary';
		summary.innerHTML = `<strong>An error occurred:</strong>
							<pre>${xhr.status} - ${xhr.statusText}</pre>`;
		form.prepend(summary);
	}
}
window.clearValidationErrors = function(form) {
  form.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'));
  form.querySelectorAll('.invalid-feedback, .validation-summary').forEach(el => el.remove());
}
window.showValidationErrors = function(form, response) {
  window.clearValidationErrors(form);

  // Build summary
  const summary = document.createElement('div');
  summary.className = 'alert alert-danger validation-summary';
  summary.innerHTML = '<strong>There were validation errors:</strong><ul></ul>';
  const list = summary.querySelector('ul');

  for (const [field, messages] of Object.entries(response.errors)) {
    const input = form.querySelector(`[name="${field}"]`);
    const msg = messages.join(', ');
    const li = document.createElement('li');
    li.textContent = `${field}: ${msg}`;
    list.appendChild(li);

    if (input) {
      input.classList.add('is-invalid');
      // only add per-field message if desired
      const err = document.createElement('div');
      err.className = 'invalid-feedback';
      err.textContent = msg;
      input.after(err);
    }
  }

  form.prepend(summary);
}
window.showToast = function (message, severity) {

	const headerClasses = {
		success: 'bg-success text-white',
		info: 'bg-info text-white',
		warning: 'bg-warning text-dark',
		danger: 'bg-danger text-white'
	};

	// set severity to success if not recognized
	severity = typeof severity === 'string' && headerClasses[severity] ? severity : 'success';

	// set the delay by severity, if 0, the toast stays until the user dismisses the toast
	const delay = {
		success: 10000,
		info:    10000,
		warning: 0,
		danger:  0,
	};

	const delayAttribute = delay[severity] === 0 ? '' : `data-delay="${delay[severity]}"`;
	const toastId = 'toast-' + Date.now();
	const escapedMessage = $('<div>').text(message).html();

	const toastHtml = `
		<div id="${toastId}" class="toast" role="alert" ${delayAttribute}>
			<div class="toast-header ${headerClasses[severity]}">
				<strong class="mr-auto">${severity.charAt(0).toUpperCase() + severity.slice(1)}</strong>
				<button type="button" class="ml-2 mb-1 close" data-dismiss="toast">&times;</button>
			</div>
			<div class="toast-body">${escapedMessage}</div>
		</div>`;

	const $toast = $(toastHtml);
	$('#toastContainer').append($toast);

	$toast.toast('show').on('hidden.bs.toast', function () {
		$(this).remove();
	});
};

/**
 * Handles the json response on success/error
 * Display the the message as toast and return true if processed, false if not processable
 *
 * @param {jqXHR} xhr   reponse, the content should have the 'success' key, which should be boolean and be true or false, it may have message (string) or messages (array of strings)
 * @returns {boolean}   true if handled the response (if xhr has a responseJSON)
 */
window.handleJsonResponse = function(xhr) {
	// Check that xhr exists and has a valid responseJSON with a 'success' key
	if (!xhr || typeof xhr.responseJSON !== 'object' || !('success' in xhr.responseJSON)) {
		console.warn('Unable to parse JSON response.');
		return false;
	}

	const response = xhr.responseJSON;
	const severity = response.success === true ? 'success' : 'danger';

	let messages = [];

	// Handle single message
	if (typeof response.message === 'string') {
		messages.push(response.message);
	}

	// Handle multiple messages
	if (response.messages) {
		if (Array.isArray(response.messages)) {
			messages.push(...response.messages); // spread array into messages
		} else if (typeof response.messages === 'string') {
			messages.push(response.messages); // fallback if messages is a string
		}
	}

	// Show all messages as toasts
	messages.forEach(msg => {
		if (typeof msg === 'string' && msg.trim()) {
			window.showToast(msg.trim(), severity);
		}
	});

	return true;
};

window.handleLegacyPopupModalResponse = function(responseData,status,xhr, modalOptions){
	if(window.wasLegacyPopupClosed(responseData)) {
		// success, refresh table and close hide the modal
		window.$bootstrapTable.bootstrapTable('refresh');
		window.legacyPopupModalDispose();
		return;
	} else {
		// remove existing modals anyway, we will popup another one
		window.legacyPopupModalDispose()

		if(window.handleJsonResponse(xhr)) {
			window.$bootstrapTable.bootstrapTable('refresh');
			return
		};
	}


	// make a modal with the form displayed in the responseData
	var responseHtml = $(responseData);
	var mainBodyElement = responseHtml.find('#mainbody,.mainbody').first();
	if (mainBodyElement.length == 0) mainBodyElement = $('<div>'+responseData+'</div>').find('#mainbody,.mainbody').first(); // seems like sometimes it doesn't get it is a dom, so we wrap it inside a <div>
	if (mainBodyElement.length == 0) mainBodyElement = responseHtml.find('main.py-2');
	if (mainBodyElement.length == 0) mainBodyElement = responseHtml.find('body');
	if (mainBodyElement.length == 0) mainBodyElement = $('<div><p>'+responseData+'</p></div>');
	var responseElement = $('<div></div>')
	responseElement.append(mainBodyElement.html());

	var title_element = responseElement.find('h1').first();

	// if response not html, add a title and a close button
	if(title_element.length == 0) title_element = $('<h1>Message</h1>');
	if(responseElement.find('input').length == 0) responseElement.append($('<button onclick="window.legacyPopupModalDispose()">Close</button>'))

	var title = title_element.text();
	title_element.remove();
	var modal = window.modalCreate(modalOptions);
	window.modalPopulate(modal,()=>({ 'title':title, 'contents':responseElement }));

	// execute scripts we got from the response WARNING: this may produce bugs and unexpected results
	responseHtml.filter('script').each(function(){
		$.globalEval(this.text || this.textContent || this.innerHTML || '');
	});


	// careful to dispose of the modal, cause there is a little bug with serializeArray() stacking submits if we don't
	modal.on('hidden.bs.modal', function(){
		$(this).modal('dispose').remove();
	});

	// cosmetics with css bootstrap
	modal.find('.modal-footer').remove();
	var buttons = modal.find('input[type="submit"]:not(.btn),input[type="button"]:not(.btn),button:not(.btn)')
	buttons.addClass('btn btn-sm');
	buttons.not('input[type="button"],button').addClass('btn-primary');
	buttons.not('input[type="submit"]').addClass('btn-secondary');
	modal.find(`
		input[type="text"]:not(.form-control),
		input[type="password"]:not(.form-control),
		textarea:not(.form-control),
		select:not(.form-control)
	`).addClass('form-control form-control-sm')

	// lookup for Cancel/Close/Back buttons and make them just close the modal and refresh the table
	modal.find('input[type="button"][value*="Cancel"],input[type="button"][value*="Back"],button:contains("Cancel"),button:contains("Back"),button:contains("Close")').each(function(k,e){
		$(e).removeAttr('onclick');
		$(e).on('click',function(ee){
			window.$bootstrapTable.bootstrapTable('refresh');
			ee.preventDefault();
			window.legacyPopupModalDispose();
			return false;
		})
	});

	// TODO: handle js functions instead of raw form send
	// prepare the event on form use
	modal.find('form').each(function(k,e){
		var form = $(e);
		e.submit = function(z){
			form.trigger('submit');
		}
		form.on('submit',function(fe){
			// if already prevented by a onsubmit function, abort
			if(fe.originalEvent !== undefined && fe.originalEvent.defaultPrevented) return false;

			// prevent default behaviour if still going
			fe.preventDefault();

			// get original form data
			var form_element = form;
			var method = form_element.attr("method");
			var data = form_element.serializeArray();
			$('input[type="submit"]').each((k,i)=> data.push({ name: i.name, value: i.value })) // because serialize doesn't include input[type="submit"] ...
			var action = form_element.attr('action') === undefined ? xhr.url  : form_element.attr('action');

			// send the request and handle the response
			$.ajax({
				url: action,
				type: method,
				data: data,
				beforeSend: function(jqXHR, settings) {
					jqXHR.url = action;
				},
				error: function(xhr) {
					window.handleLegacyPopupModalResponseFailure(xhr, form);
				},
				success: handleLegacyPopupModalResponse // loop through this function if there is a response
			})
		})
	})

	modal.modal({
		backdrop: true,
		show: true
	});

}

window.modalCreate = function(options = {}){
	var extraClasses = '';
	if(options.small) extraClasses+=" modal-sm ";
	if(options.large) extraClasses+=" modal-lg ";
	if(options.extraLarge) extraClasses+=" modal-xl ";

	var modal_id = 'modal-'+Math.random().toString(36).slice(2);
	var modal_element = $(`
	<div class="modal fade" id="`+modal_id+`" tabindex="-1" aria-labelledby="`+modal_id+`-label" aria-hidden="true">
		<div class="modal-dialog `+extraClasses+` ">
			<div class="modal-content">
			<div class="modal-header">
				<h2 class="modal-title" id="`+modal_id+`-label">Modal title</h2>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div id="`+modal_id+`-contents" class="modal-body"></div>
			<div id="`+modal_id+`-footer" class="modal-footer">
				<div id="`+modal_id+`-controls" class="flex-fill">
				</div>
				<button type="button" class="btn btn-sm btn-light align-self-end" data-dismiss="modal">Close</button>
			</div>
			</div>
		</div>
	</div>
	`);
	$("div#mainbody:first").append(modal_element);

	return modal_element;
}
window.modalPopulate = function(modal_element,callbackInfo){
	var modal_id = modal_element.prop('id');
	var label_id    = modal_id+'-label';
	var contents_id = modal_id+'-contents';
	var controls_id   = modal_id+'-controls';

	var label_element    = modal_element.find('#'+label_id);
	var contents_element = modal_element.find('#'+contents_id);
	var controls_element   = modal_element.find('#'+controls_id);


	var info = callbackInfo()

	label_element.text(info.title);
	contents_element.append(info.contents);
	controls_element.prepend(info.controls);

	return modal_element;
}
window.modalPopulateRequest = function(modal_element,uri,method,options){
	if(!options) options = {};
	if(!method) method = 'GET';
	return modalPopulate(modal_element,function(){
		var response = sendRequest(method,uri,options,null);

		return {
			'title':response.title,
			'contents':response.contents,
			'controls':response.controls,
		}
	})
}
window.modalPopulateJs = function(modal_element,title,contents,controls){
	return modalPopulate(modal_element,function(){

		return {
			'title':title,
			'contents':contents,
			'controls':controls,
		}
	})
}

window.toggleBootstrapBtn = function(){
	return toggleBootstrap('bootstrap_btn_only.css')
}
window.toggleBootstrapPlacement = function(){
	return toggleBootstrap('bootstrap_placement_only.css')
}
window.toggleBootstrapCommonTags = function(){
	return toggleBootstrap('bootstrap_common_tags.css')
}
window.toggleBootstrap = function(css_file){
	if ($('link[rel=stylesheet][href$="'+css_file+'"]').length > 0){
		$('link[rel=stylesheet][href$="'+css_file+'"]').remove()
	} else {
		$('head').append('<link rel="stylesheet" type="text/css" href="'+asset('css/')+css_file+'">');
	}
}
window.asset = function(path){
	return cfg_common_web_root + 'resources/assets/' + path.replace(/^\//, '');
}


window.RefreshOpenersDataTable = function(e){
	if(window.opener){
		console.log('windows opener detected, refresh opener and close self')
		if(window.opener.$bootstrapTable) window.opener.$bootstrapTable.bootstrapTable('refresh');
		else if( $('iframe',window.opener.document).length > 0) $('iframe',window.opener.document).attr( 'src', function ( i, val ) { return val; });
		else window.opener.location.reload(false);
	} else {
		if(window.$bootstrapTable) window.$bootstrapTable.bootstrapTable('refresh');
	}
}
window.RefreshOpenersDataTableAndClose = function(e){
	window.RefreshOpenersDataTable(e);
	if(window.opener) window.close();
	else if(legacyPopupModalFindAll().length > 0 ){ // is modal
		legacyPopupModalDispose();
	}
}
window.openPopupWithLoadingAnimation = function (message, url, title, options){
	var popup = window.open('', title, options);
	popup.document.body.innerHTML = "<br>&nbsp;<b style='font-family: Verdana, Arial, Helvetica, Swiss, sans-serif;font-size:10px'>"+message+"...</b>";
	popup.location = url;
}


window.SecsToMinsSecs = function(seconds){
    let minutes = Math.floor(seconds / 60);
    let extraSeconds = seconds % 60;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    extraSeconds = extraSeconds < 10 ? "0" + extraSeconds : extraSeconds;
    return minutes+":"+extraSeconds;
}

window.phpToMomentDateFormat = function(phpFormat) {
    var formatMapping = {
        'Y': 'YYYY',
        'y': 'YY',
        'm': 'MM',
        'n': 'M',
        'd': 'DD',
        'j': 'D',
        'H': 'HH',
        'h': 'hh',
        'i': 'mm',
        's': 'ss',
        'a': 'a',
        'A': 'A',
        'e': '',
        'O': 'ZZ',
        'P': 'Z',
        'T': 'z',
    };

    var momentFormat = phpFormat.replace(/(Y|y|m|n|d|j|H|h|i|s|a|A|e|O|P|T)/g, function (match) {
        return formatMapping[match];
    });

    return momentFormat;
}

window.spanLocalDateTimeBase = function(isoTime, timeFormat, cssClass='', attributes='', tooltipInfo=true){

    switch (timeFormat) {
        case 0: default: cssClass += " utc-to-local-datetime"; break;
        case 1:          cssClass += " utc-to-local-date"; break;
        case 2:          cssClass += " utc-to-local-time"; break;
    }
    if(tooltipInfo){
        // todo tooltip with moment js (may need to be activated on displayLocalDateTime )
        // attributes += " data-toggle='tooltip' "
        // attributes += " title='' "
    }

    return "<span "+attributes+" class='"+cssClass+"' data-iso-datetime='"+isoTime+"'></span>";
}

window.spanLocalDateTime = function(isoTime, cssClass='', attributes='', tooltipInfo=true){ return window.spanLocalDateTimeBase(isoTime, 0, cssClass, attributes, tooltipInfo); }
window.spanLocalDate     = function(isoTime, cssClass='', attributes='', tooltipInfo=true){ return window.spanLocalDateTimeBase(isoTime, 1, cssClass, attributes, tooltipInfo); }
window.spanLocalTime     = function(isoTime, cssClass='', attributes='', tooltipInfo=true){ return window.spanLocalDateTimeBase(isoTime, 2, cssClass, attributes, tooltipInfo); }
window.spanBooleanCheckTimes = function(value, cssClass='', attributes=''){ return'<span '+attributes+' class="'+cssClass+'"><i class="fas fa-'+(value?'check text-success':'times text-danger')+'"></i></span>'; }

